import { Injectable } from "@angular/core";
import { AuthService } from "src/app/components/auth/service/auth.service";

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsInitializer {
  private apiKeyUpdateInterval = 6 * 60 * 60 * 1000;
  private currentApiKey: string | null = null;
  private scriptLoaded = false;

  constructor(private authService: AuthService) {}

  async initialize(): Promise<void> {
    if (!this.scriptLoaded) {
      await this.setApiKey();
      await this.loadGoogleMapsScript();
      setInterval(() => this.reloadPage(), this.apiKeyUpdateInterval);
    }
  }

  private async setApiKey(): Promise<void> {
    try {
      const res = await this.authService.getGoogleKeys().toPromise();
      if (res?.key) {
        this.currentApiKey = res.key;
      } else {
        throw new Error('No API key returned');
      }
    } catch (error) {
      console.error('Failed to get API key', error);
      // throw error;
    }
  }

  private loadGoogleMapsScript(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.scriptLoaded || typeof google !== 'undefined') {
        this.scriptLoaded = true;
        return resolve();
      }

      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDVBKTPEJQhXYGcV-NlLYLj_4xa9TvePjI&libraries=places,marker&v=beta`;
      script.async = true;
      script.defer = true;

      script.onload = () => {
        this.scriptLoaded = true;
        resolve();
      };
      script.onerror = (err) => {
        console.error('Failed to load Google Maps script:', err);
        reject(err);
      };

      document.head.appendChild(script);
    });
  }

  private reloadPage(): void {
    window.location.reload();
  }
}
